import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventLabel, GaTrackingEventName, GATrackingEventType} from '../../constants';
import { Product } from '~shared/models';
import get from 'lodash.get';

export class GATrackingPromoViewEvent implements GATrackingEvent {

  constructor(
    private products: Product[],
    private index: number,
    private categoryName: string,
    private label: string) {

  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PromoView;
  }

  getPayload(): GATrackingEventPayload {
    const startIndex = this.index + 1;
    const productPromoViewTracking = {
      ecommerce: {
        promoView: {
          promotions: this.products.map((item: Product, index: number) => {
            return {
              'id': get(item, 'id'),
              'name': get(item, 'name'),
              'format': 'carousel',
              'creative': get(this.categoryName, 'name'),
              'position': index + startIndex
            };
          })
        }
      }
    };

    return {
      event: GaTrackingEventName.PromoView,
      label: this.label,
      gtmCustom: productPromoViewTracking
    };
  }
}
